var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiPoweredSales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69,
    height: 68.593,
    viewBox: "0 0 69 68.593",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "finance-advisor_16852774",
    transform: "translate(-10 -10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    "data-name": "Path 1041",
    d: "M24.29,35.722A20.03,20.03,0,0,1,44.3,15.715a25.677,25.677,0,0,1,6.431.84V10.72A31.383,31.383,0,0,0,44.3,10,25.718,25.718,0,0,0,18.574,35.722L10,51.441V52.87a1.818,1.818,0,0,0,1.4,1.708l5.744,1.15.993,8.614a6.588,6.588,0,0,0,6.369,5.677h8.356l2.859,8.574h6.023l-3.86-11.58a4.248,4.248,0,0,0-3.763-2.71H24.507a.971.971,0,0,1-.692-.62l-1.47-12.744-5.016-1,6.96-12.758V35.722Z",
    fill: "#7b7bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1042",
    "data-name": "Path 1042",
    d: "M62.5,10h4.287V25.763H62.5Z",
    transform: "translate(-7.486)",
    fill: "#7b7bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    d: "M82.5,10h4.287V25.72H82.5Z",
    transform: "translate(-10.338)",
    fill: "#7b7bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    d: "M42.5,33.334h4.287V51.911H42.5Z",
    transform: "translate(-4.634 -3.327)",
    fill: "#7b7bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M55.361,36.908V23.334H42.5v4.287h8.574V41.2H61.792V36.908Z",
    transform: "translate(-4.634 -1.901)",
    fill: "#7b7bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    d: "M81.7,41.525l-9.2-9.2V10h4.287V30.548l7.946,7.946Z",
    transform: "translate(-8.912 0)",
    fill: "#7b7bff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(70 35.593)",
    fill: "#7b7bff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 4.287,
    cy: 4.287,
    r: 4.287,
    transform: "translate(70.018 24.29)",
    fill: "#7b7bff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 4.287,
    cy: 4.287,
    r: 4.287,
    transform: "translate(52.87 32.864)",
    fill: "#7b7bff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 4.287,
    cy: 4.287,
    r: 4.287,
    transform: "translate(52.87 21.433)",
    fill: "#7b7bff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(36 44.593)",
    fill: "#7b7bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1047",
    "data-name": "Path 1047",
    d: "M67.148,50A17.148,17.148,0,1,0,84.3,67.148,17.146,17.146,0,0,0,67.148,50Zm5.716,12.861H64.29v2.858h5.715a2.858,2.858,0,0,1,2.859,2.859v2.858a2.858,2.858,0,0,1-2.859,2.858H68.577v2.859H65.719V74.293H61.432V71.435h8.574V68.577H64.29a2.858,2.858,0,0,1-2.859-2.859V62.861A2.858,2.858,0,0,1,64.29,60h1.428V57.145h2.859V60h4.287Z",
    transform: "translate(-5.704 -5.704)",
    fill: "#7b7bff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiPoweredSales);
export default __webpack_public_path__ + "static/media/ai-powered-sales.3cba155e91458a83dddb38e04ea017c0.svg";
export { ForwardRef as ReactComponent };